import ResourceModal from 'app/components/ResourceModal';
import ResourceModalPanel from 'app/components/ResourceModalPanel';
import BillingForm from './BillingForm';

const BillingPanel = props => {
  const {
    billing,
    action,
    onClose,
    onDelete
  } = props;

  // if we're creating a customer then no actions panel will be shown
  if (action === 'create') {
    return null;
  }

  let cards = [
    {
      label: 'Delete Billing Entity',
      message: 'Removes the Billing Entity and related Account Billing records.',
      actions: [
        { label: 'Delete Billing Entity', callback: onDelete }
      ]
    }
  ]

  return (
    <div>
      <ResourceModalPanel cards={cards} />
    </div>
  )
}

const BillingModal = props => {
  const {
    isOpen,
    onClose,
    onFormSubmit,
    onDestroy,
    billing
  } = props;

  let title, subTitle = null;

  if (billing) {
    title = billing.name;
  } else {
    title = 'New Billing';
  }

  const action = billing ? 'update' : 'create';

  const onSubmit = params => onFormSubmit(action, params);
  const onDelete = () => onDestroy(billing.id);

  return (
    <ResourceModal {...{ isOpen, onClose, title, subTitle }}>
      <BillingPanel {...{ billing, action, onClose, onDelete }} />
      <BillingForm {...{ billing, action, onClose, onSubmit }} />
    </ResourceModal>
  );
}

export default BillingModal;
